import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function MDAdminDashboard() {
  return (
    <Dashboard sidebarType="Managing Director">
      <DashboardConfig />
    </Dashboard>
  );
}
